<script>
import {mapGetters} from "vuex";
import moment from "moment";

export default {
    name: "PurchaseRentPlan",

    data() {
        return {
            startDateValue: null,
            endDateValue: null,
            startDateMasks: {
                input: 'MM/DD/YYYY',
            },
            serverUrl: process.env.VUE_APP_URL
        }
    },

    computed: {
        ...mapGetters({
            countryPackages: 'purchase/getCountryPackages',
            planDevices: 'purchase/getPlanDevices',
            orderData: 'purchase/getOrderData',
            activeOrderDataIndex: 'purchase/getActiveOrderDataIndex',
        }),
        startMinDate() {
            return new Date(Date.now());
        },
        endMinDate() {
            let date = new Date(Date.now());
            date = date.setDate(this.startMinDate.getDate() + 1);
            if (this.startDateValue) {
                date = moment(this.startDateValue).add(1, "day").format();
            }
            return date;
        },
        activeOrder() {
            return this.orderData[this.activeOrderDataIndex];
        },
        dayPackages() {
            return this.countryPackages.filter(pkg => {return pkg.package_type === 'day'})
        },
        monthPackages() {
            return this.countryPackages.filter(pkg => {return pkg.package_type === 'month'})
        },
        activeTypePackages() {
            let activePackages = [];

            if (this.activeOrder.plan_type === 'month') {
                activePackages = this.monthPackages;
            } else {
                activePackages = this.dayPackages;
            }

            return activePackages;
        },
        isShowMonthType() {
            let value = false;
            let availableCountryIds = [198, 180];

            if (availableCountryIds.includes(this.activeOrder.country_api_id)
                && this.monthPackages.length > 0
            ) {
                value = true;
            }

            return value;
        },
        isShowDeviceType() {
            let value = false;
            let availableCountryIds = [198];
            let availablePickupLocationIds = [354];

            if (availableCountryIds.includes(this.activeOrder.country_api_id)
                && (this.activeOrder.plan_type === 'month'
                || availablePickupLocationIds.includes(this.activeOrder.pickup_location_api_id))
            ) {
                return true;
            }

            if (this.activeOrder.shipment_type === 'delivery' 
                && availableCountryIds.includes(this.activeOrder.country_api_id)
            ) {
                return true;
            }

            return value;
        },
        getWifiRentalPeriodText() {
            let numberOfDays = this.activeOrder.number_of_days;
            let text = `Your WiFi Rental Period: <span class="orange">${numberOfDays}</span> ${this.activeOrder.plan_type}`;

            if (numberOfDays > 1)  {
                text += 's';
            }

            return text;
        }
    },

    created() {
        this.init();
    },

    methods: {
        init() {
            this.startDateValue = this.activeOrder.start_date || moment().format();
            this.$store.dispatch('purchase/setStartDate', this.startDateValue);

            this.endDateValue = this.activeOrder.end_date;
            this.$store.dispatch('purchase/setEndDate', this.endDateValue);
            if (this.endDateValue) {
                let diffDays = moment(this.endDateValue).startOf('day').diff(moment(this.startDateValue).startOf('day'), 'days');
                if (diffDays > 0) {
                    this.$store.dispatch('purchase/setNumberOfDays', diffDays);
                }
            }

            this.loadCountryPackages();
            this.loadPlanDevices();
        },
        changePlanType(type) {
            this.$store.dispatch("purchase/setPlanType", type);
            this.$store.dispatch("purchase/setPickupLocation", {});
            this.$store.dispatch("purchase/setSelectedDevice", {});
            this.$store.dispatch("purchase/setCoupon", {});
            this.$store.dispatch('purchase/setNumberOfDays', 1);

            if (this.activeOrder.plan_type === 'month' && this.monthPackages.length) {
                this.$store.dispatch('purchase/selectPlan', this.monthPackages[0]);
                this.$store.dispatch('purchase/setEndDate', null);
            }

            if (this.activeOrder.plan_type === 'day' && this.dayPackages.length) {
                this.$store.dispatch('purchase/selectPlan', this.dayPackages[0]);
                this.endDateValue = null;
            }
        },
        selectStartDate(value) {
            this.$store.dispatch('purchase/setStartDate', moment(value.date).format());
            this.$store.dispatch('purchase/setPickupDate', null);
            this.setDiffDays();
            this.$store.dispatch('purchase/setEndDate', null);
            this.endDateValue = null;
            this.$store.dispatch('purchase/setNumberOfDays', 1);
        },
        selectEndDate(value) {
            this.$store.dispatch('purchase/setEndDate', moment(value.date).format());
            this.setDiffDays();
        },
        setDiffDays() {
            if (this.activeOrder.plan_type === 'month') {
                return;
            }
            if (!this.endDateValue) {
                this.$store.dispatch('purchase/setNumberOfDays', 1);
                return;
            }
            let diffDays = moment(this.endDateValue).startOf('day').diff(moment(this.startDateValue).startOf('day'), 'days');
            this.$store.dispatch('purchase/setNumberOfDays', diffDays);
        },
        handleNumberOfDays(type) {
            let numberOfDays = this.activeOrder.number_of_days;
            if (type === 'minus' && numberOfDays > 1) {
                this.$store.dispatch('purchase/setNumberOfDays', numberOfDays - 1);
            } else if (type === 'plus') {
                this.$store.dispatch('purchase/setNumberOfDays', numberOfDays + 1);
            }
        },
        handleNumberOfDevices(type) {
            let numberOfDevices = this.activeOrder.number_of_devices;
            if (type === 'minus' && numberOfDevices > 1) {
                this.$store.dispatch('purchase/setNumberOfDevices', numberOfDevices - 1);
            } else if (type === 'plus') {
                this.$store.dispatch('purchase/setNumberOfDevices', numberOfDevices + 1);
            }
        },
        handlePlan(plan) {
            this.$store.dispatch('purchase/selectPlan', plan);
        },
        handleDeviceType(device) {
            this.$store.dispatch('purchase/setSelectedDevice', device);
        },
        async loadCountryPackages() {
            let orderData = this.activeOrder;
            if (orderData.country_id && !this.countryPackages.length) {
                try {
                    const response = await this.$axios.get(`/countries/${orderData.country_id}/get-country-packages`);
                    this.$store.dispatch('purchase/setCountryPackages', response.data);
                } catch (error) {
                    console.error("Error while fetching packages:", error);
                }
            }
        },
        async loadPlanDevices() {
            try {
                const response = await this.$axios.get(`/devices/get-devices`);
                this.$store.dispatch('purchase/setPlanDevices', response.data);
            } catch (error) {
                console.error("Error while fetching devices:", error);
            }
        },
    }
}
</script>

<template>
    <div class="purchase-rent-plan">
        <div class="purchase-rent-plan__title">
            <h1>{{ $t("purchase-rent-page.plans.selectPlan") }}</h1>
        </div>

        <div class="purchase-rent-plan__types">
            <div class="purchase-rent-plan__switcher">
                <div
                    :class="`purchase-rent-plan__switcher-day ${activeOrder.plan_type === 'day' ? 'active' : ''} ${!isShowMonthType ? 'w-full' : ''}`"
                    @click="changePlanType('day')"
                >
                    {{ $t("purchase-rent-page.plans.dayPlans") }}
                </div>
                <div
                    v-if="isShowMonthType"
                    class="purchase-rent-plan__switcher-month"
                    :class="{'active': activeOrder.plan_type === 'month'}"
                    @click="changePlanType('month')"
                >
                    {{ $t("purchase-rent-page.plans.monthPlans") }}
                </div>
            </div>
        </div>

        <h5 class="purchase-rent-plan__description">
            {{ $t("purchase-rent-page.plans.description").replace('$country', activeOrder.country_name || 'your destination') }}
        </h5>

        <div class="purchase-rent-plan__body">
            <h1
                class="purchase-rent-plan__body-title"
                v-html="getWifiRentalPeriodText"
            ></h1>

            <div class="br"></div>

            <div class="purchase-rent-plan__body-date">
                <div class="purchase-rent-plan__body-date__start-date">
                    <h4>{{ $t("purchase-rent-page.plans.selectStartDate") }}</h4>
                    <h5>{{ $t("purchase-rent-page.plans.selectStartDateHint") }}</h5>

                    <v-date-picker
                        v-model="startDateValue"
                        :masks="startDateMasks"
                        :min-date="startMinDate"
                        @dayclick="selectStartDate"
                    >
                        <template v-slot="{ inputValue, inputEvents }">
                            <div class="relative">
                                <input
                                    class="purchase-rent-plan__body-date__start-date__input"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    placeholder="Select start date"
                                />
                                <svg class="date-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FF8818"><path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z"/></svg>
                            </div>
                        </template>
                    </v-date-picker>
                </div>
                <template v-if="activeOrder.plan_type === 'day'">
                    <div class="purchase-rent-plan__body-date__start-date">
                        <h4>{{ $t("purchase-rent-page.plans.selectEndDate") }}</h4>
                        <h5>{{ $t("purchase-rent-page.plans.selectEndDateHint") }}</h5>

                        <v-date-picker
                            v-model="endDateValue"
                            :masks="startDateMasks"
                            :min-date="endMinDate"
                            @dayclick="selectEndDate"
                        >
                            <template v-slot="{ inputValue, inputEvents }">
                                <div class="relative">
                                    <input
                                        class="purchase-rent-plan__body-date__start-date__input"
                                        :value="inputValue"
                                        v-on="inputEvents"
                                        placeholder="Select start date"
                                    />
                                    <svg class="date-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FF8818"><path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z"/></svg>
                                </div>
                            </template>
                        </v-date-picker>
                    </div>
                </template>
                <template v-if="activeOrder.plan_type === 'month'">
                    <div class="purchase-rent-plan__body-date__number-of-days">
                        <h4>{{ $t("purchase-rent-page.plans.numberOf").replace("$day", activeOrder.plan_type === 'month' ? 'months' : 'days') }}</h4>
                        <h5>{{ $t("purchase-rent-page.plans.numberOfHint") }}</h5>

                        <div class="purchase-rent-plan__body-date__number-of-days__input">
                            <div
                                class="minus"
                                @click="handleNumberOfDays('minus')"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FF8818"><path d="M200-440v-80h560v80H200Z"/></svg>
                            </div>
                            <div class="number">
                                {{ activeOrder.number_of_days }}
                            </div>
                            <div
                                class="plus"
                                @click="handleNumberOfDays('plus')"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FF8818"><path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/></svg>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <div class="br"></div>

            <h2>{{ $t("purchase-rent-page.plans.choosePlanType") }}</h2>

            <div class="purchase-rent-plan__body-plan-types">
                <div
                    v-if="activeTypePackages.length"
                    v-for="plan in activeTypePackages"
                    class="purchase-rent-plan__body-plan-type"
                    :class="{'active': activeOrder.plan_id === plan.id}"
                    @click="handlePlan(plan)"
                >
                    <div class="flex justify-between">
                        <div class="purchase-rent-plan__body-plan-type-info">{{ plan.name }}</div>
                        <div v-if="plan.note" class="purchase-rent-plan__body-plan-type-note">
                            <div class="purchase-rent-plan__body-plan-type-note__item" v-html="plan.note"></div>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#7DD3FC"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                        </div>
                    </div>
                    <div 
                        v-if="plan.description" 
                        class="purchase-rent-plan__body-plan-type-des"
                        v-html="plan.description"
                    ></div>
                    <div class="purchase-rent-plan__body-plan-type-price">
                        ${{ plan.price }} Per {{ activeOrder.plan_type === 'month' ? 'month' : 'day' }}
                    </div>
                </div>
                <div
                    v-if="!activeTypePackages.length"
                    class="font-light"
                >
                    {{ $t("purchase-rent-page.plans.selectDestinationFirst") }}
                </div>
            </div>

            <div class="br"></div>

            <template
                v-if="isShowDeviceType && planDevices.length"
            >
                <h2>{{ $t("purchase-rent-page.plans.deviceType") }}</h2>

                <div
                    class="purchase-rent-plan__body-device-types"
                >
                    <div
                        v-for="device in planDevices"
                        class="purchase-rent-plan__body-device-type"
                        :class="{'active': activeOrder.device_type === device.type}"
                        @click="handleDeviceType(device)"
                    >
                        <img v-if="device.type == 1" :src="`${serverUrl}/image/plan-device-type-1.png`" alt="">
                        <img v-if="device.type == 2" :src="`${serverUrl}/image/plan-device-type-2.png`" alt="">
                        <h5>{{ device.name }}</h5>
                        
                        <div v-if="device.note" class="purchase-rent-plan__body-device-type-note">
                            <div class="purchase-rent-plan__body-device-type-note__item" v-html="device.note"></div>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#7DD3FC"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                        </div>
                    </div>
                </div>

                <div class="br"></div>
            </template>

            <h2>{{ $t("purchase-rent-page.plans.deviceQuantity") }}</h2>

            <div class="purchase-rent-plan__body-device-quantity">
                <h4>{{ $t("purchase-rent-page.plans.numberOfDevices") }}</h4>

                <div class="purchase-rent-plan__body-date__number-of-days__input">
                    <div
                        class="minus"
                        @click="handleNumberOfDevices('minus')"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FF8818"><path d="M200-440v-80h560v80H200Z"/></svg>
                    </div>
                    <div class="number">
                        {{ activeOrder.number_of_devices }}
                    </div>
                    <div
                        class="plus"
                        @click="handleNumberOfDevices('plus')"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FF8818"><path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/></svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.purchase-rent-plan {
    position: relative;
    margin-top: 2rem;

    &__title {
        margin-bottom: 2rem;

        h1 {
            text-align: left;
            font-size: 24px;
            font-weight: 400;
            margin-bottom: .5rem;
        }
    }

    &__types {
        background: #fff;
        margin-bottom: 1.5rem;
    }

    &__switcher {
        border-radius: 8px;
        border: 2px solid #7DD3FC;
        padding: .25rem;
        width: 100%;
        display: flex;
        justify-content: space-between;

        &-day, &-month {
            border-radius: 8px;
            text-align: center;
            font-size: 1rem;
            font-weight: 500;
            height: 60px;
            width: 49.8%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            background: #fff;

            &:hover {
                color: #7DD3FC;

                &.active {
                    color: #fff;
                }
            }

            &.active {
                background: #7DD3FC;
                color: #fff;
            }
        }
    }

    &__description {
        font-weight: 300;
        font-size: 14px;
        margin-bottom: 1.5rem;
    }

    &__body {
        background: #ffffff;
        border: 2px solid #7DD3FC;
        border-radius: 8px;
        padding: 1.5rem 1rem;

        h2 {
            font-weight: 400;
            font-size: 1rem;
            margin-bottom: 1.5rem;
        }

        &-title {
            font-size: 1.8rem;
            font-weight: 400;
            margin-bottom: 1.5rem;

            .orange {
                color: #FE9634;
                font-weight: 500;
                font-size: 2.2rem;
            }
        }

        .br {
            border: 1px solid #7DD3FC;
            margin-bottom: 1.5rem;
            width: 100%;
        }

        &-date {
            display: flex;
            justify-content: space-between;
            margin-bottom: 1.5rem;
            width: 100%;

            h4 {
                font-size: 16px;
                font-weight: 400;
                margin-bottom: .5rem;
            }

            h5 {
                font-size: 14px;
                font-weight: 300;
                margin-bottom: 1rem;
            }

            &__start-date {
                width: 48%;

                &__input {
                    width: 100%;
                    box-sizing: border-box;
                    background: #ffffff;
                    border: 2px solid #FE9634;
                    border-radius: 8px;
                    padding: .8rem 3rem;
                    font-size: 1rem;
                    outline: none;
                }

                .date-icon {
                    position: absolute;
                    top: .9rem;
                    left: 1rem;
                }
            }

            &__number-of-days {
                width: 48%;

                &__input {
                    background: #ffffff;
                    border: 2px solid #FE9634;
                    border-radius: 8px;
                    padding: 0 1rem;
                    height: 53px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .plus, .minus {
                        cursor: pointer;
                    }

                    .number {
                        font-weight: 500;
                        font-size: 26px;
                        color: #FE9634;
                        user-select: none;
                    }
                }
            }
        }

        &-plan-types {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 1.5rem;
        }

        &-plan-type {
            background: #ffffff;
            width: 147px;
            padding: 1rem;
            border-radius: 8px;
            border: 2px solid #7DD3FC;
            cursor: pointer;
            margin: 0 1rem 1rem 0;

            &:hover, &.active {
                color: #ffffff;
                background: #7DD3FC;

                svg {
                    fill: #ffffff;
                }
            }

            &-info {
                font-size: 18px;
                font-weight: 500;
                margin-bottom: .5rem;
            }

            &-des {
                width: 100%;
                display: inline-block;
                font-size: 16px;
                font-weight: 300;
                margin-bottom: .5rem;
            }

            &-price {
                font-size: 16px;
                font-weight: 500;
            }

            &-note {
                position: relative;

                &__item {
                    display: none;
                    position: absolute;
                    bottom: 2.2rem;
                    left: -80px;
                    background-color: #ffffff;
                    font-size: 14px;
                    font-weight: 500;
                    color: #000000;
                    width: 200px;
                    max-width: 200px;
                    padding: .5rem 1rem;
                    border-radius: 8px;
                    border: 1px solid #7DD3FC;
                    text-align: center;
                }

                &:hover {
                    .purchase-rent-plan__body-plan-type-note__item {
                        display: block;
                    }
                }
            }
        }

        &-device-types {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 1.5rem;
        }

        &-device-type {
            border-radius: 8px;
            border: 2px solid #7DD3FC;
            background: #ffffff;
            padding: 1rem;
            margin: 0 1rem 1rem 0;
            width: 160px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            cursor: pointer;

            img {
                height: 64px;
                margin-bottom: .5rem;
            }

            h5 {
                width: 100%;
                text-align: center;
                font-size: 1rem;
            }

            &:hover, &.active {
                color: #ffffff;
                background: #7DD3FC;

                svg {
                    fill: #ffffff;
                }
            }

            &-note {
                position: relative;

                &__item {
                    display: none;
                    position: absolute;
                    bottom: 2.2rem;
                    left: -80px;
                    background-color: #ffffff;
                    font-size: 14px;
                    font-weight: 500;
                    color: #000000;
                    width: 200px;
                    max-width: 200px;
                    padding: .5rem 1rem;
                    border-radius: 8px;
                    border: 1px solid #7DD3FC;
                    text-align: center;
                }

                &:hover {
                    .purchase-rent-plan__body-device-type-note__item {
                        display: block;
                    }
                }
            }
        }

        &-device-quantity {
            width: 50%;

            h4 {
                font-size: 16px;
                font-weight: 400;
                margin-bottom: .5rem;
            }
        }
    }
}
</style>